import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

// web-instance-identity: זהות המופע — שם הסביבה (sys.instance.name_he) ולוגו החברה. GET /api/instance/brand פתוח בלי התחברות
// (עמוד הכניסה מציג אותו); logoUrl נושא ?v=<sha> שמתחלף עם הלוגו, כך שלוגו שהוחלף מתעדכן בלי ניקוי מטמון.
export type Brand = { nameHe: string; logoUrl: string | null };

async function fetchBrand(): Promise<Brand> {
  const r = await fetch('/api/instance/brand');
  if (!r.ok) throw new Error(`brand ${r.status}`);
  const b = (await r.json()) as Partial<Brand>;
  return { nameHe: typeof b.nameHe === 'string' ? b.nameHe : '', logoUrl: typeof b.logoUrl === 'string' ? b.logoUrl : null };
}

export function useBrand(): Brand | null {
  const q = useQuery({ queryKey: ['instance-brand'], queryFn: fetchBrand, staleTime: 5 * 60_000, retry: 1 });
  return q.data ?? null;
}

/** כותרת הלשונית: `<עמוד> · <שם הסביבה>` (עד שהשם נטען — העמוד בלבד). */
export function useDocTitle(page: string) {
  const brand = useBrand();
  useEffect(() => {
    document.title = brand?.nameHe ? `${page} · ${brand.nameHe}` : page;
  }, [page, brand?.nameHe]);
}
